// extracted by mini-css-extract-plugin
module.exports = {"modal":"MenuModal_modal__3ip1L"};